import { Helmet } from "react-helmet"
import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import Header from "../../../components/Header"
import Layout from "../../../components/Layout"
import ThumbnailImage from "../../../images/thumbnails/gitex_thumb.png"

export function Index() {
  return (
    <Layout
      title="How Premagic Transformed GITEX Global 2024"
      description="How GITEX Global, the world’s largest tech event, empowered 170,000+ attendees to become content creators through Premagic’s AI photo platform in Dubai."
      metaImage={ThumbnailImage}
      keywords={[
        "GITEX Global case study, Dubai tech conference, world largest tech event, Middle East technology summit, Dubai innovation showcase, Gulf tech conference, Arab world tech events, GITEX Dubai photos, tech expo networking, international tech summit, UAE technology events, Dubai startup showcase, Middle East innovation hub, global tech gathering, Dubai tech ecosystem",
      ]}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Case Studies", url: "/case-study/" },
        { name: "GITEX Global", url: "/case-study/gitex-global/" },
      ]}
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "How Premagic Transformed GITEX Global 2024",
            "description": "How GITEX Global, the world’s largest tech event, empowered 170,000+ attendees to become content creators through Premagic’s AI photo platform in Dubai.",
            "image": "https://premagic.com" + ThumbnailImage,
            "author": {
              "@type": "Organization",
              "name": "Premagic",
            },
            "publisher": {
              "@type": "Organization",
              "name": "Premagic",
              "logo": {
                "@type": "ImageObject",
                "url": "https://premagic.com/icons/icon-144x144.png",
              },
            },
            "datePublished": "2024-10-15",
            "dateModified": "2025-01-15",
          })}
        </script>
      </Helmet>
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.GITEX_GLOBAL} />
    </Layout>
  )
}

export default Index
